import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Modal from 'react-modal';
import swal from 'sweetalert2';
import { connect } from 'react-redux';
import { Icon, translate } from '@haldor/ui';
var customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: '2147'
  },
  content: {
    backgroundColor: 'transparent',
    border: '0',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    padding: '0',
    minHeight: '100%',
    overflow: 'auto',
    zIndex: '2150',
    WebkitOverflowScrolling: 'touch'
  }
};
Modal.setAppElement('#root');
var ModalObject = /*#__PURE__*/function (_Component) {
  function ModalObject() {
    var _this;
    _classCallCheck(this, ModalObject);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ModalObject, [].concat(args));
    _defineProperty(_this, "onModalClick", function (e) {
      e.stopPropagation();
    });
    _defineProperty(_this, "shouldClose", function () {
      if (_this.props.isOpen && !_this.props.overridePrompt) {
        swal({
          title: _this.props.translate('Are you sure?'),
          text: _this.props.translate('Are you sure you want to close the form?'),
          showCancelButton: true,
          cancelButtonText: _this.props.translate('no'),
          confirmButtonText: _this.props.translate('yes')
        }).then(function (result) {
          if (result.value != null) {
            _this.props.onClose();
          }
        });
      } else {
        _this.props.onClose();
      }
    });
    return _this;
  }
  _inherits(ModalObject, _Component);
  return _createClass(ModalObject, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: props.isOpen,
        onRequestClose: this.shouldClose,
        contentLabel: "",
        style: _objectSpread(_objectSpread({}, customStyles), props.style)
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-overlay",
        onClick: this.shouldClose
      }, /*#__PURE__*/React.createElement("div", {
        className: props.type ? "modal-container ".concat(props.type) : 'modal-container',
        onClick: this.onModalClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header",
        style: {
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "title",
        style: {
          flex: 1,
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("h2", {
        style: {
          margin: 0,
          lineHeight: 1.2
        }
      }, props.title)), /*#__PURE__*/React.createElement("button", {
        className: "close",
        onClick: props.onClose,
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer'
        },
        "aria-label": this.props.translate ? this.props.translate('Close') : 'Close'
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Close"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, props.children))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(ModalObject);